// services/axiosConfig.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // Cette option permet à Axios d'envoyer les cookies avec chaque requête
});

export default axiosInstance;
